<template>
   <v-card height="100" style="border-radius: 8px">
      <v-container class="pa-0 fill-height" >
         <div class="layout row ma-0">
            <div :class="{'sm6 xs6': !dense, 'sm4 xs4': dense}" class="flex">
               <div class="layout column ma-0 justify-center align-center fill-height">
                  <v-icon :color="color" :size="iconSize" style="min-width: 40px;"> {{icon}}</v-icon>
               </div>
            </div>
            <div :class="rightClass" style="border-radius: 8px"
                 class="flex text-sm-center py-4 white--text">
               <div class="headline">{{ title }}
                  <v-icon class="v-icon material-icons" color="white">{{trendingIcon}}</v-icon>
               </div>
               <span class="caption">{{ subTitle }}</span>
            </div>
         </div>
      </v-container>
   </v-card>
</template>

<script>
   export default {
      props: {
         icon: String,
         trendingIcon: String,
         title: [String, Number],
         subTitle: String,
         color: String,
         dense: {
            type: Boolean,
            default: false
         }
      },

      computed: {
         rightClass () {
            return (!this.dense ? ' sm6 xs6 ' : ' sm8 xs8 ') + this.color;
         },

         iconSize () {
            return !this.dense ? '48px' : '40px';
         }
      }
   };
</script>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/widgets/statistic/MiniStatistic.vue